<template>
  <div style="display:flex">
    <RadioGroup v-model="feeType" style="margin-right:30px;" type="button">
      <Radio label="折扣"></Radio>
      <Radio label="定额"></Radio>
    </RadioGroup>
    <div style="display:inline-block" v-show="feeType==='折扣'">
      <p>
        <span>折扣方式：</span>
        <Select style="width:150px" v-model="discountType">
          <Option value="先折扣后计算"></Option>
          <Option value="先计算后折扣"></Option>
        </Select>
      </p>
      <p style="margin:10px 0">
        <span>计费标准：</span>
        <Select style="width:150px" v-model="chargingStandard">
          <Option value="采购预算"></Option>
          <Option value="中标/成交金额"></Option>
        </Select>
      </p>
      <span>折扣率：</span>
      <Input v-model="feeDiscount" type="text" style="width:80px"></Input>
      <span>%</span>
    </div>
    <div style="display:inline-block" v-show="feeType==='定额'">
      <span>类型：</span>
      <Select style="width:100px;" v-model="quotaType">
        <Option value="项目定额"></Option>
        <Option value="中标人定额"></Option>
      </Select>
      <span style="margin-left:10px;">服务费：</span>
      <Input type="text" v-model="quota" style="width:100px;"></Input>
    </div>
  </div>
</template>

<script>
import { getFee } from '@/lib/serviceFee'
export default {
  name: 'serviceFee',
  props: {
    serviceData: {
      type: Object
    }
  },
  data() {
    return {
      feeType: '',
      feeDiscount: '',
      quotaType: '',
      quota: '',
      discountType: '',
      chargingStandard: ''
    }
  },
  methods: {
    getResult() {
      if (this.feeType === '') {
        this.$Message.error('请选择服务费类型')
        return
      }
      if (this.feeType === '折扣') {

        if (this.discountType === '') {
          this.$Message.error('折扣方式不能为空')
          return
        }
        if (this.chargingStandard === '') {
          this.$Message.error('计费标准不能为空')
          return
        }
        if (this.feeDiscount === '') {
          this.$Message.error('折扣率不能为空')
          return
        }
        if (!/^\d+(\.\d+)?$/.test(this.feeDiscount)) {
          this.$Message.error('折扣率请填写数字')
          return
        }
        const cgtype = (this.serviceData.cgtype === '服务' || this.serviceData.cgtype === '工程') ? this.serviceData.cgtype : '货物'
        if (this.discountType === '先折扣后计算') {
          return {
            feeType: '折扣',
            discount: this.feeDiscount,
            fee: getFee(this.serviceData.amount * (this.feeDiscount / 100), 100, cgtype)
          }
        } else {
          return {
            feeType: '折扣',
            discount: this.feeDiscount,
            fee: getFee(this.serviceData.amount, this.feeDiscount, cgtype)
          }
        }
      } else if (this.feeType === '定额') {

        if (this.quotaType === '' || this.quota === '') {
          this.$Message.error('定额类型或定额服务费不能为空')
          return
        }
        return {
          feeType: this.quotaType,
          fee: this.quota
        }
      }
    }
  }
}
</script>
